import { clearingApi } from "../../config/apiConfig";

export const getPaymentSumsOverview = async () => {
  try {
    const response = await clearingApi.get(`payment-sums/overview`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch payment sums overview", error);
    throw error;
  }
};

export const refreshRecentPaymentSums = async () => {
  try {
    const response = await clearingApi.post(`payment-sums/refresh-recent`);
    return response.data;
  } catch (error) {
    console.error("Failed to refresh recent payment sums", error);
    throw error;
  }
};

export const refreshPaymentSumMonth = async ({ year, month }) => {
  try {
    const response = await clearingApi.post(
      `payment-sums/refresh-month?year=${year}&month=${month}`
    );
    return response.data;
  } catch (error) {
    console.error("Failed to refresh payment sum month", error);
    throw error;
  }
};
